{
  document.querySelectorAll('.share .share--link').forEach(linkEl => {
    linkEl.addEventListener('click', e => {
      e.preventDefault()

      const link = e.currentTarget
      const notice = link.querySelector('.copied-notice')

      if (!notice) {
        console.log("No notice element found.")
        return
      }

      navigator.clipboard.writeText(link.href)
        .then(() => {
          notice.classList.add('active')
          setTimeout(() => {
            notice.classList.remove('active')
          }, 2250)
        })
        .catch(err => console.error("Failed to copy:", err))
    })
  })
}